<footer class="text-body-secondary text-center text-small">
    <p class="mb-1">&copy; 2025 Luvema - Dorpelbestellen.nl <a class="luvemafooterlink" href="#">versie 1.9.2</a> gepubliceerd op 01-05-2025 </p>
    <p class="mb-1 owner-label">Powered by Luvema</p>
    <div class="logo-wrapper">
        <img class="logo" src="assets/logo.jpg" alt="owner-logo"/>
    </div>
</footer>